// Renders a DOM node to a multi-page PDF via html2canvas + jsPDF, rather than
// drawing text directly with jsPDF's built-in fonts — those only cover
// Latin-1/WinAnsi, so Azerbaijani characters (ə, ş, ç, ğ, ı, ...) would come
// out as missing glyphs. Rasterizing the browser's own rendering sidesteps
// that entirely at the cost of the PDF text not being selectable.
const exportSheetToPdf = async (node, filename) => {
  const [{ default: jsPDF }, { default: html2canvas }] = await Promise.all([
    import('jspdf'),
    import('html2canvas'),
  ]);

  const canvas = await html2canvas(node, { scale: 2, backgroundColor: '#ffffff', useCORS: true });
  const imgData = canvas.toDataURL('image/png');

  const pdf = new jsPDF('p', 'pt', 'a4');
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position -= pageHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }

  pdf.save(filename);
};

export default exportSheetToPdf;
